import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { SchemasTypes, SchemaInterface } from './types';

// List Schema
export const listSchemaRequest = (payload?: object) =>
  action(SchemasTypes.LIST_SCHEMA_REQUEST, payload);
export const listSchemaSuccess = (payload: { schemaList: SchemaInterface }) =>
  action(SchemasTypes.LIST_SCHEMA_SUCCESS, payload);
export const listSchemaFailure = () => action(SchemasTypes.LIST_SCHEMA_FAILURE);
